import {
  Button,
  Modal,
  TextField,
  IconButton,
  Select,
  FormControl,
  MenuItem,
} from "@mui/material"
import MDBox from "../MDBox"
import MDTypography from "../MDTypography"
import moment from "moment/moment"
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker"
import { DesktopDateTimePicker } from "@mui/x-date-pickers/DesktopDateTimePicker"

import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment"
import { useEffect, useState } from "react"
import CloseIcon from "@mui/icons-material/Close"
import MDSelect from "components/MDSelect"

const DATE_FORMAT = "DD/MM/YYYY HH:mm"

const categories = [
  { value: "MKT_ACTIVITY", label: "MKT activity" },
  { value: "HOME_LEARNING", label: "Home Learning" },
  { value: "GRAMMAR", label: "Grammar" },
  { value: "OUTINGS", label: "Outings" },
  { value: "PROJECT", label: "Project" },
  { value: "ONBOARD", label: "Onboard" },
  { value: "TRAINING", label: "Trainings" },
  { value: "WORKSHOPS", label: "Workshops" },
  { value: "MEETING", label: "Meeting" },
]

const ModalActionEvent = ({
  isOpen,
  onSubmit = () => {},
  onClose = () => {},
  date,
  triggerCenters,
  isLoadingCenters,
}) => {
  // const navigate = useNavigate();

  const [state, setState] = useState({
    name: "",
    category: null,
    center: null,
    startDate: moment(),
    endDate: moment().endOf("day"),
    location: null,
    description: null,
  })
  const [error, setError] = useState({})
  const [centers, setCenters] = useState([])

  const validate = () => {
    const error = {}
    if (!state.name) {
      error.name = "Event name is required"
    }
    if (!state.category) {
      error.category = "Category is required"
    }
    if (!state.center) {
      error.center = "Center is required"
    }

    if (state.startDate && state.endDate) {
      if (moment(state.startDate).isAfter(moment(state.endDate))) {
        error.startDate = "Start time must be before end time"
      }
    } else {
      if (!state.startDate) {
        error.startDate = "Start time is required"
      }
      if (!state.endDate) {
        error.endDate = "End time is required"
      }
    }

    setError(error)
    return Object.keys(error).length === 0
  }

  const handleApiList = async () => {
    try {
      const resp = await triggerCenters({ page: 1, size: 100, sort: "" })
      if (resp.isSuccess && resp.data.status) {
        setCenters(
          resp.data?.data?.map((center) => ({
            value: center.id,
            label: center.name,
          }))
        )
      }
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  useEffect(() => {
    handleApiList()
  }, [])

  return (
    <>
      <Modal open={isOpen} onClose={onClose}>
        <div className="modal-leave-application-container">
          <div className="modal-leave-application-container-wrapper">
            <MDBox className="modal-leave-application-header">
              <MDBox>
                <MDTypography
                  className="modal-leave-application-title"
                  variant="h5"
                >
                  Create Event
                </MDTypography>
              </MDBox>
              <IconButton onClick={onClose} size="small">
                <CloseIcon />
              </IconButton>
            </MDBox>

            <MDBox className="modal-leave-application-content">
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <MDBox className="modal-leave-application-form">
                  <MDBox className="modal-leave-application-form-group modal-leave-application-form-group-name">
                    <MDTypography
                      variant="subtitle2"
                      className="modal-leave-application-form-dates-pick"
                    >
                      Event name <sup>*{error.name && <>Required</>}</sup>
                    </MDTypography>
                    <TextField
                      fullWidth
                      placeholder="Event name"
                      value={state.name}
                      onChange={(e) => {
                        setState({ ...state, name: e.target.value })
                      }}
                      sx={{ mb: 1 }}
                    />
                  </MDBox>

                  <MDBox className="modal-leave-application-form-group modal-leave-application-form-group-category">
                    <MDTypography
                      variant="subtitle2"
                      className="modal-leave-application-form-dates-pick"
                    >
                      Category <sup>*{error.category && <>Required</>}</sup>
                    </MDTypography>
                    <FormControl
                      sx={{ minWidth: 160, width: "100%" }}
                      size="medium"
                    >
                      <MDSelect
                        options={categories}
                        value={state.category}
                        onChange={(value) => {
                          setState({ ...state, category: value })
                        }}
                        placeholder="Select Category"
                      />
                    </FormControl>
                  </MDBox>
                  {/* select dropdown center */}
                  <MDBox className="modal-leave-application-form-group modal-leave-application-form-group-name">
                    <MDTypography
                      variant="subtitle2"
                      className="modal-leave-application-form-dates-pick"
                    >
                      Center <sup>*{error.center && <>Required</>}</sup>
                    </MDTypography>
                    <MDSelect
                      disabled={isLoadingCenters}
                      options={centers}
                      value={state.center}
                      onChange={(value) => {
                        console.log(value, "value")

                        setState({ ...state, center: value })
                      }}
                      placeholder="Select Center"
                    />
                  </MDBox>

                  <MDBox className="modal-leave-application-form-dates">
                    <MDBox sx={{ flex: 1 }}>
                      <MDTypography
                        variant="subtitle2"
                        className="modal-leave-application-form-dates-pick"
                      >
                        Start date{" "}
                        <sup>*{error.startDate && <>Required</>}</sup>
                      </MDTypography>

                      <DesktopDateTimePicker
                        className="date-time-picker"
                        value={state.startDate || moment()}
                        onChange={(newValue) => {
                          setState({
                            ...state,
                            startDate: moment(newValue),
                          })
                        }}
                        renderInput={(params) => <TextField {...params} />}
                        allowKeyboardControl
                        format={`DD/MM/YYYY HH:mm`}
                      />
                    </MDBox>
                    <MDBox sx={{ flex: 1 }}>
                      <MDTypography
                        variant="subtitle2"
                        className="modal-leave-application-form-dates-pick"
                      >
                        End date <sup>*{error.endDate && <>Required</>}</sup>
                      </MDTypography>

                      <DateTimePicker
                        className="date-time-picker"
                        value={state.endDate || moment().endOf("day")}
                        onChange={(newValue) => {
                          setState({
                            ...state,
                            endDate: moment(newValue),
                          })
                        }}
                        renderInput={(params) => <TextField {...params} />}
                        allowKeyboardControl
                        format={`DD/MM/YYYY HH:mm`}
                      />
                    </MDBox>
                  </MDBox>

                  <MDBox>
                    <MDTypography
                      variant="subtitle2"
                      className="modal-leave-application-form-dates-pick"
                    >
                      Location
                    </MDTypography>
                    <TextField
                      className="modal-leave-application-form-reason-box"
                      fullWidth
                      multiline
                      rows={4}
                      placeholder="Input detail here"
                      value={state.location}
                      onChange={(e) => {
                        setState({ ...state, location: e.target.value })
                      }}
                    />
                  </MDBox>

                  <MDBox>
                    <MDTypography
                      variant="subtitle2"
                      className="modal-leave-application-form-dates-pick"
                    >
                      Description
                    </MDTypography>
                    <TextField
                      className="modal-leave-application-form-reason-box"
                      fullWidth
                      multiline
                      rows={4}
                      placeholder="Input detail here"
                      value={state.description}
                      onChange={(e) => {
                        // setReason(e.target.value);
                        setState({ ...state, description: e.target.value })
                      }}
                    />
                  </MDBox>
                </MDBox>
              </LocalizationProvider>
            </MDBox>

            <MDBox className="modal-leave-application-footer">
              <Button
                sx={{ textTransform: "none" }}
                variant="outlined"
                onClick={onClose}
                className="cancel-button"
              >
                Cancel
              </Button>
              <Button
                sx={{ textTransform: "none" }}
                className="submit-button"
                variant="contained"
                color="primary"
                onClick={() => {
                  if (!validate()) return
                  onSubmit(state)
                }}
              >
                Submit
              </Button>
            </MDBox>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default ModalActionEvent
